<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/Mfb3Bv/tc-custom/9781949090727.jpg?1728851932626" alt="This image is the cover for the book Forbidden Love Collection Books 1–3, The Forbidden Love Novels"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Forbidden Love Collection Books 1–3, The Forbidden Love Novels
      </h1>
      <p class="bookDescription body article font2">
        <b>Three novels—<i>Forbidden by Faith</i>, <i>Forbidden by Destiny</i>, <i>Forbidden by Time</i>—in the series that “shows how family, love, and faith can collide” in one ebook (A. K. Leigh, author of </b><i><b>See Her Run).</b></i> <br/>  <br/> From award-winning contemporary romance author, Negeen Papehn, comes a multicultural exploration of love and romance, family and friendship, and the ties that bind . . .<br/>  <br/><b><i>Forbidden by Faith </i></b><b>(Book 1)</b><br/>  <br/> Raised by her Iranian immigrant parents, Sara has been taught that a good daughter makes decisions based on her family’s approval. She’s spent most of her life in their good graces—until she meets Maziar . . .<br/>  <br/><b><i>Forbidden by Destiny</i></b><b> (Book 2)</b><br/>  <br/> Leyla’s loyalty is tested when she finds herself falling for her best friend’s ex-boyfriend. His pain speaks to Leyla’s heart, and she suddenly finds herself feeling what it’s like to fall in love for the first time ever.<br/>  <br/><b><i>Forbidden by Time</i></b><b> (Book 3)</b><br/>  <br/> Bita is determined to stand on her own two feet. She’s purchasing her first home, and ultimately, her independence. But when Bita meets a sexy, older real estate agent, a simple property transaction blooms into a fierce desire that leaves her breathless.<br/>  <br/><b>Praise for the Forbidden Love series</b><br/>  <br/> “A heartfelt immigrant love story.”—<i>Publishers Weekly</i><br/>  <br/> “Ms. Papehn is a wonderful storyteller! I was immediately caught up in the lives of her characters. In <i>Forbidden by Destiny</i>, the heroine, Leyla, might be of Iranian descent but her story belongs to all women.”—Carrie Nichols, author of the Small-town Sweethearts series<br/>  <br/> “A strong message about family and protecting those you love.”—<i>InD’tale Magazine</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Negeen Papehn
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      City Owl Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?5a0d056a